/* tslint:disable */
/* eslint-disable */
/**
 * Lumen Failure Management API
 * <h5>ToDo: API description</h5>
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    ExcelColumn,
    ExcelColumnFromJSON,
    ExcelColumnFromJSONTyped,
    ExcelColumnToJSON,
    FilterLogicalOperator,
    FilterLogicalOperatorFromJSON,
    FilterLogicalOperatorFromJSONTyped,
    FilterLogicalOperatorToJSON,
    SortingDto,
    SortingDtoFromJSON,
    SortingDtoFromJSONTyped,
    SortingDtoToJSON,
} from './';

/**
 * 
 * @export
 * @interface WorkBookTaskItemReportExcelQuery
 */
export interface WorkBookTaskItemReportExcelQuery {
    /**
     * 
     * @type {string}
     * @memberof WorkBookTaskItemReportExcelQuery
     */
    timeZone?: string | null;
    /**
     * 
     * @type {Array<ExcelColumn>}
     * @memberof WorkBookTaskItemReportExcelQuery
     */
    columns?: Array<ExcelColumn> | null;
    /**
     * 
     * @type {number}
     * @memberof WorkBookTaskItemReportExcelQuery
     */
    page?: number | null;
    /**
     * 
     * @type {number}
     * @memberof WorkBookTaskItemReportExcelQuery
     */
    pageSize?: number | null;
    /**
     * 
     * @type {number}
     * @memberof WorkBookTaskItemReportExcelQuery
     */
    skip?: number;
    /**
     * 
     * @type {number}
     * @memberof WorkBookTaskItemReportExcelQuery
     */
    take?: number;
    /**
     * 
     * @type {FilterLogicalOperator}
     * @memberof WorkBookTaskItemReportExcelQuery
     */
    filterLogicalOperator?: FilterLogicalOperator;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof WorkBookTaskItemReportExcelQuery
     */
    filterKeys?: { [key: string]: any; } | null;
    /**
     * 
     * @type {Array<SortingDto>}
     * @memberof WorkBookTaskItemReportExcelQuery
     */
    sortings?: Array<SortingDto> | null;
}

export function WorkBookTaskItemReportExcelQueryFromJSON(json: any): WorkBookTaskItemReportExcelQuery {
    return WorkBookTaskItemReportExcelQueryFromJSONTyped(json, false);
}

export function WorkBookTaskItemReportExcelQueryFromJSONTyped(json: any, ignoreDiscriminator: boolean): WorkBookTaskItemReportExcelQuery {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'timeZone': !exists(json, 'timeZone') ? undefined : json['timeZone'],
        'columns': !exists(json, 'columns') ? undefined : (json['columns'] === null ? null : (json['columns'] as Array<any>).map(ExcelColumnFromJSON)),
        'page': !exists(json, 'page') ? undefined : json['page'],
        'pageSize': !exists(json, 'pageSize') ? undefined : json['pageSize'],
        'skip': !exists(json, 'skip') ? undefined : json['skip'],
        'take': !exists(json, 'take') ? undefined : json['take'],
        'filterLogicalOperator': !exists(json, 'filterLogicalOperator') ? undefined : FilterLogicalOperatorFromJSON(json['filterLogicalOperator']),
        'filterKeys': !exists(json, 'filterKeys') ? undefined : json['filterKeys'],
        'sortings': !exists(json, 'sortings') ? undefined : (json['sortings'] === null ? null : (json['sortings'] as Array<any>).map(SortingDtoFromJSON)),
    };
}

export function WorkBookTaskItemReportExcelQueryToJSON(value?: WorkBookTaskItemReportExcelQuery | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'timeZone': value.timeZone,
        'columns': value.columns === undefined ? undefined : (value.columns === null ? null : (value.columns as Array<any>).map(ExcelColumnToJSON)),
        'page': value.page,
        'pageSize': value.pageSize,
        'skip': value.skip,
        'take': value.take,
        'filterLogicalOperator': FilterLogicalOperatorToJSON(value.filterLogicalOperator),
        'filterKeys': value.filterKeys,
        'sortings': value.sortings === undefined ? undefined : (value.sortings === null ? null : (value.sortings as Array<any>).map(SortingDtoToJSON)),
    };
}


